(() => {
  const root = document.querySelector('[data-nini-favorites-page]');
  if (!root) return;

  const storageKey = 'nini:favorites:v1';
  const grid = root.querySelector('[data-nini-favorites-grid]');
  const countElement = root.querySelector('[data-nini-favorites-count]');
  const statusElement = root.querySelector('[data-nini-favorites-status]');
  const emptyElement = root.querySelector('[data-nini-favorites-empty]');
  const sortSelect = root.querySelector('[data-nini-favorites-sort]');
  const dialog = root.querySelector('[data-nini-favorites-dialog]');
  const dialogContent = root.querySelector('[data-nini-favorites-dialog-content]');
  const notifyDialog = root.querySelector('[data-nini-favorites-notify-dialog]');
  const notifyForm = root.querySelector('#NiniFavoriteNotifyForm');
  const notifyBodyInput = root.querySelector('[data-nini-favorites-notify-body]');
  const notifyProductInput = root.querySelector('[data-nini-favorites-notify-product]');
  const notifyTypeInput = root.querySelector('[data-nini-favorites-notify-type]');
  const notifyEmailInput = root.querySelector('[data-nini-favorites-notify-email]');
  const notifyTitleElement = root.querySelector('[data-nini-favorites-notify-title]');
  const notifyTextElement = root.querySelector('[data-nini-favorites-notify-text]');
  const fallbackScript = root.querySelector('[data-nini-favorites-fallback]');
  const proxyPrefix = window.location.pathname.startsWith('/proxy/mobile')
    ? '/proxy/mobile'
    : window.location.pathname.startsWith('/proxy/desktop')
      ? '/proxy/desktop'
      : '';
  const withProxy = (url) => (proxyPrefix && String(url).startsWith('/') ? `${proxyPrefix}${url}` : url);
  const cartAddUrl = withProxy(root.dataset.cartAddUrl || '/cart/add.js');
  const cartUrl = withProxy(root.dataset.cartUrl || '/cart');
  const notifyUrl = withProxy(root.dataset.notifyUrl || '/pages/nini-club');
  const notifyMode = root.dataset.notifyMode || 'form';
  const customerEmail = root.dataset.customerEmail || '';
  const showDemoWhenEmpty = root.dataset.demoWhenEmpty === 'true';
  const externalGlobalKeys = [
    'niniWishlistItems',
    'niniFavoritesItems',
    '__niniWishlistItems',
    '__niniFavoritesItems',
    'swymWishlistItems',
    'wishlistItems',
    'favoriteItems',
  ];
  const xenithExclusiveProductId = '11020562137281';
  const priorityOnlyProductIds = new Set(['11020562137281', '11107226910913', '11107245326529', '11033868992705']);
  const priorityOnlyVariantIds = new Set(['50400603865281', '50400618512577', '50400619921601', '50711865000129', '50711901143233', '50456804786369', '50456804819137', '50456804851905', '50712681480385']);
  const priorityOnlyHandles = new Set(['torvault', 'xc-デッキスポンジ', 'xc-カスタムスポンジ', 'nini-ink']);
  const isPublicPurchaseBlocked = (item) => {
    if (!item || typeof item !== 'object') return false;
    const ids = [item.id, item.productId, item.product_id, item.variantId, item.variant_id].map(value => String(value || ''));
    if (ids.some(id => priorityOnlyProductIds.has(id) || priorityOnlyVariantIds.has(id))) return true;
    const handle = String(item.handle || item.productHandle || item.product_handle || '').toLowerCase();
    if (priorityOnlyHandles.has(handle)) return true;
    try {
      const url = new URL(item.url || item.productUrl || item.product_url || item.du || '', window.location.origin);
      return priorityOnlyHandles.has(decodeURIComponent(url.pathname).split('/products/')[1]?.replace(/\/$/, '').toLowerCase());
    } catch (_error) {
      return false;
    }
  };

  const isXenithExclusiveProduct = (item) => {
    if (!item || typeof item !== 'object') return false;
    const id = String(item.id || item.productId || item.product_id || '');
    const handle = String(item.handle || item.productHandle || item.product_handle || '').toLowerCase();
    const url = String(item.url || item.productUrl || item.product_url || item.du || '').toLowerCase();
    return id === xenithExclusiveProductId
      || handle === 'torvault'
      || /\/products\/torvault(?:[/?#]|$)/.test(url);
  };

  let activeFilter = 'all';
  let activeView = 'grid';
  let productsCache = new Map();
  let fallbackItems = [];
  let lastExternalSignature = '';

  const dispatchAnalytics = (eventName, detail = {}) => {
    window.dispatchEvent(new CustomEvent('nini:analytics:event', {
      detail: {
        event: eventName,
        source: 'favorites_page',
        ...detail,
      },
    }));
  };

  const track = (eventName, detail = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      nini_source: 'favorites_page',
      ...detail,
    });
    dispatchAnalytics(eventName, detail);
  };

  const uniqueById = (items) => {
    const seen = new Set();
    return items.filter((item) => {
      if (isXenithExclusiveProduct(item)) return false;
      const id = String(item?.id || item?.productId || item?.product_id || item?.url || '');
      if (!id || seen.has(id)) return false;
      seen.add(id);
      return true;
    });
  };

  const normalizeExternalFavorite = (item, index) => {
    if (!item || typeof item !== 'object') return null;
    const image = item.image || item.imageUrl || item.image_url || item.featured_image || item.featuredImage || item.product_image || '';
    const price = item.price || item.priceText || item.formatted_price || item.product_price || '';
    return {
      id: item.id || item.productId || item.product_id || item.variantId || item.variant_id || item.url || index,
      title: item.title || item.productTitle || item.product_title || item.name || 'nini item',
      url: item.url || item.productUrl || item.product_url || item.du || '/collections/all',
      price,
      priceNumber: item.priceNumber || item.price_number || item.price_cents || item.priceInCents || '',
      image,
      category: item.category || item.productType || item.product_type || item.type || '',
      productType: item.productType || item.product_type || item.type || '',
      variantId: item.variantId || item.variant_id || item.variant || '',
      compareAtPrice: item.compareAtPrice || item.compare_at_price || item.comparePrice || '',
      badge: item.badge || item.tag || '',
      available: item.available !== false,
      popularity: item.popularity || 0,
      source: item.source || 'wishlist_app',
      addedAt: item.addedAt || item.createdAt || item.created_at || new Date().toISOString(),
      notifyUrl: item.notifyUrl || item.notify_url || '',
    };
  };

  const readExternalFavorites = () => {
    const externalItems = [];
    externalGlobalKeys.forEach((key) => {
      const value = window[key];
      if (Array.isArray(value)) {
        value.forEach((item, index) => {
          const normalized = normalizeExternalFavorite(item, index);
          if (normalized) externalItems.push(normalized);
        });
      }
    });

    document.querySelectorAll('[data-nini-external-wishlist]').forEach((script) => {
      try {
        const parsed = JSON.parse(script.textContent || '[]');
        if (Array.isArray(parsed)) {
          parsed.forEach((item, index) => {
            const normalized = normalizeExternalFavorite(item, index);
            if (normalized) externalItems.push(normalized);
          });
        }
      } catch (_error) {
        // Ignore malformed app payloads so the page remains usable.
      }
    });

    return uniqueById(externalItems);
  };

  const syncExternalIfChanged = () => {
    const externalItems = readExternalFavorites();
    const signature = JSON.stringify(externalItems.map((item) => `${item.id}:${item.addedAt || ''}`));
    if (signature === lastExternalSignature) return externalItems.length;
    lastExternalSignature = signature;
    if (externalItems.length > 0) {
      track('nini_wishlist_external_detected', { favorite_count: externalItems.length });
      render();
    }
    return externalItems.length;
  };

  const readFavorites = () => {
    try {
      const parsed = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
      const localItems = Array.isArray(parsed) ? parsed.filter((item) => item && item.id) : [];
      return uniqueById([...readExternalFavorites(), ...localItems]);
    } catch (_error) {
      return readExternalFavorites();
    }
  };

  const writeFavorites = (items) => {
    window.localStorage.setItem(storageKey, JSON.stringify(items.filter((item) => !isXenithExclusiveProduct(item))));
  };

  const setStatus = (message) => {
    if (!statusElement) return;
    statusElement.textContent = message || '';
    if (message) {
      window.clearTimeout(setStatus.timeout);
      setStatus.timeout = window.setTimeout(() => {
        statusElement.textContent = '';
      }, 3200);
    }
  };

  const updateGlobalFavoriteCount = (count) => {
    document.querySelectorAll('[data-nini-favorite-count]').forEach((counter) => {
      counter.textContent = String(count);
      counter.hidden = count === 0;
      counter.setAttribute('aria-label', `お気に入り${count}件`);
    });
  };

  const announceFavoriteChange = (action, item, favorites) => {
    window.dispatchEvent(new CustomEvent('nini:favorites:changed', {
      detail: {
        action,
        item,
        favorites,
        count: favorites.length,
      },
    }));
    track(`nini_favorite_${action}`, {
      product_id: item.id,
      product_title: item.title,
      product_url: item.url,
      favorite_count: favorites.length,
    });
  };

  const normalizePriceNumber = (value) => {
    if (typeof value === 'number') return value;
    if (!value) return 0;
    const numeric = String(value).replace(/[^\d]/g, '');
    return Number(numeric) * 100 || 0;
  };

  const parseHandle = (item) => {
    const url = item.url || '';
    const match = url.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  };

  const inferCategory = (item) => {
    const text = [
      item.category,
      item.productType,
      item.type,
      item.title,
      Array.isArray(item.tags) ? item.tags.join(' ') : item.tags,
      item.badge,
    ].filter(Boolean).join(' ').toLowerCase();

    if (text.includes('sale') || text.includes('セール')) return 'sale';
    if (text.includes('ヘア') || text.includes('hair') || text.includes('clip') || text.includes('リボン')) return 'hair';
    if (text.includes('beauty') || text.includes('ビューティ') || text.includes('リップ') || text.includes('コスメ')) return 'beauty';
    if (text.includes('character') || text.includes('キャラクター') || text.includes('おぱんちゅ') || text.includes('ぬい')) return 'character';
    return 'keyholder';
  };

  const enrichItem = (item, index, source = 'favorite') => {
    const priceNumber = Number(item.priceNumber || item.price_number || normalizePriceNumber(item.price));
    return {
      ...item,
      id: String(item.id || item.url || item.title || index),
      title: item.title || 'nini item',
      url: item.url || '/collections/all',
      image: item.image || '',
      price: item.price || (priceNumber ? `¥${Math.round(priceNumber / 100).toLocaleString()}` : ''),
      priceNumber,
      compareAtPrice: item.compareAtPrice || item.compare_at_price || '',
      category: inferCategory(item),
      badge: item.badge || (source === 'favorite' ? '' : 'NEW'),
      source,
      addedAt: item.addedAt || new Date(0).toISOString(),
      variantId: item.variantId || item.variant_id || null,
      available: item.available !== false,
      popularity: Number(item.popularity || 0),
    };
  };

  const getFallbackItems = () => {
    if (!fallbackScript) return [];
    try {
      const parsed = JSON.parse(fallbackScript.textContent || '[]');
      return Array.isArray(parsed) ? parsed.map((item, index) => enrichItem(item, index, 'recommendation')) : [];
    } catch (_error) {
      return [];
    }
  };

  const getItems = () => {
    const favorites = readFavorites().map((item, index) => enrichItem(item, index, 'favorite'));
    updateGlobalFavoriteCount(favorites.length);
    if (favorites.length > 0) return { items: favorites, favoriteCount: favorites.length, showingRecommendations: false };
    if (showDemoWhenEmpty && fallbackItems.length > 0) {
      return { items: fallbackItems, favoriteCount: 0, showingRecommendations: true };
    }
    return { items: [], favoriteCount: 0, showingRecommendations: false };
  };

  const sortItems = (items) => {
    const sorted = [...items];
    const mode = sortSelect?.value || 'newest';
    if (mode === 'oldest') {
      sorted.sort((a, b) => new Date(a.addedAt) - new Date(b.addedAt));
    } else if (mode === 'price-asc') {
      sorted.sort((a, b) => a.priceNumber - b.priceNumber);
    } else if (mode === 'price-desc') {
      sorted.sort((a, b) => b.priceNumber - a.priceNumber);
    } else if (mode === 'popular') {
      sorted.sort((a, b) => (b.popularity || 0) - (a.popularity || 0));
    } else {
      sorted.sort((a, b) => new Date(b.addedAt) - new Date(a.addedAt));
    }
    return sorted;
  };

  const filterItems = (items) => {
    if (activeFilter === 'all') return items;
    return items.filter((item) => item.category === activeFilter);
  };

  const escapeHtml = (value) => String(value || '').replace(/[&<>"']/g, (character) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;',
  })[character]);

  const cardImageMarkup = (item) => {
    if (!item.image) return '<span class="nini-favorite-card__placeholder">nini</span>';
    return `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" loading="lazy">`;
  };

  const renderCard = (item, index) => {
    const isRecommendation = item.source === 'recommendation';
    const isAvailable = item.available !== false;
    const ribbon = index === 0 ? '<span class="nini-favorite-card__ribbon">nini<br>CLUB<br>人気</span>' : '';
    const badge = item.badge ? `<span class="nini-favorite-card__badge">${escapeHtml(item.badge)}</span>` : '';
    const compare = item.compareAtPrice ? `<s>${escapeHtml(item.compareAtPrice)}</s>` : '';
    const heartLabel = isRecommendation ? 'お気に入りに追加' : 'お気に入りから削除';
    const heartClass = isRecommendation ? '' : ' is-favorite';
    const heartPressed = isRecommendation ? 'false' : 'true';
    const primaryAction = isPublicPurchaseBlocked(item)
      ? '<button type="button" class="nini-favorite-card__cart" disabled>カートに追加</button>'
      : isAvailable
      ? '<button type="button" class="nini-favorite-card__cart" data-nini-favorites-cart>カートに追加</button>'
      : '<button type="button" class="nini-favorite-card__notify" data-nini-favorites-notify>再入荷通知</button>';

    return `
      <article class="nini-favorite-card" data-nini-favorites-item data-id="${escapeHtml(item.id)}">
        <div class="nini-favorite-card__media-shell">
          <a class="nini-favorite-card__media" href="${escapeHtml(item.url)}" aria-label="${escapeHtml(item.title)}">
            ${cardImageMarkup(item)}
            ${ribbon}
            ${badge}
          </a>
          <button type="button" class="nini-favorite-card__heart${heartClass}" data-nini-favorites-heart aria-label="${escapeHtml(heartLabel)}" aria-pressed="${heartPressed}"></button>
        </div>
        <div class="nini-favorite-card__body">
          <h2 class="nini-favorite-card__title"><a href="${escapeHtml(item.url)}">${escapeHtml(item.title)}</a></h2>
          <span class="nini-favorite-card__club-label">♕ nini CLUB 会員特典対象</span>
          <div class="nini-favorite-card__price">
            <strong>${escapeHtml(item.price || '価格を見る')}</strong>
            ${compare}
          </div>
          <div class="nini-favorite-card__actions">
            <button type="button" class="nini-favorite-card__quick" data-nini-favorites-quick>クイックビュー</button>
            ${primaryAction}
          </div>
        </div>
      </article>
    `;
  };

  const render = () => {
    const { items, favoriteCount, showingRecommendations } = getItems();
    const visibleItems = sortItems(filterItems(items));

    if (grid) {
      grid.classList.toggle('is-list', activeView === 'list');
      grid.innerHTML = visibleItems.map(renderCard).join('');
    }

    if (countElement) {
      countElement.textContent = showingRecommendations
        ? `あなたへのおすすめ ${visibleItems.length}件`
        : `お気に入り ${visibleItems.length}件`;
    }

    if (emptyElement) {
      emptyElement.hidden = items.length > 0;
    }

    root.classList.toggle('is-showing-recommendations', showingRecommendations);
  };

  const findItemFromElement = (element) => {
    const card = element.closest('[data-nini-favorites-item]');
    if (!card) return null;
    const { items } = getItems();
    return items.find((item) => String(item.id) === String(card.dataset.id)) || null;
  };

  const removeFavorite = (item) => {
    const next = readFavorites().filter((favorite) => String(favorite.id) !== String(item.id));
    writeFavorites(next);
    updateGlobalFavoriteCount(next.length);
    announceFavoriteChange('remove', item, next);
    setStatus(`${item.title}をお気に入りから削除しました。`);
    render();
  };

  const addFavorite = (item) => {
    const favorites = readFavorites();
    if (favorites.some((favorite) => String(favorite.id) === String(item.id))) {
      setStatus('すでにお気に入りに入っています。');
      return;
    }
    const next = [{
      id: item.id,
      title: item.title,
      url: item.url,
      price: item.price,
      image: item.image,
      addedAt: new Date().toISOString(),
    }, ...favorites];
    writeFavorites(next);
    updateGlobalFavoriteCount(next.length);
    announceFavoriteChange('add', item, next);
    setStatus(`${item.title}をお気に入りに追加しました。`);
    render();
  };

  const fetchProductData = async (item) => {
    const handle = parseHandle(item);
    if (!handle) return null;
    if (productsCache.has(handle)) return productsCache.get(handle);
    const response = await fetch(withProxy(`/products/${encodeURIComponent(handle)}.js`));
    if (!response.ok) throw new Error('商品情報を取得できませんでした。');
    const product = await response.json();
    productsCache.set(handle, product);
    return product;
  };

  const getVariantId = async (item) => {
    if (item.variantId) return item.variantId;
    const product = await fetchProductData(item);
    const variant = product?.variants?.find((candidate) => candidate.available) || product?.variants?.[0];
    return variant?.id || null;
  };

  const addToCart = async (item, button) => {
    if (isPublicPurchaseBlocked(item)) return;
    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = '追加中...';
    try {
      const variantId = await getVariantId(item);
      if (!variantId) throw new Error('購入できるバリエーションが見つかりませんでした。');
      const response = await fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });
      if (!response.ok) throw new Error('カートに追加できませんでした。');
      button.textContent = '追加しました';
      setStatus(`${item.title}をカートに追加しました。`);
      track('nini_favorite_add_to_cart', {
        product_id: item.id,
        product_title: item.title,
        product_url: item.url,
        variant_id: variantId,
      });
      window.setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 1800);
    } catch (error) {
      button.textContent = originalText;
      button.disabled = false;
      setStatus(error.message || 'カート追加に失敗しました。商品ページで種類を選んでください。');
      window.setTimeout(() => {
        window.location.href = item.url || cartUrl;
      }, 1300);
    }
  };

  const openQuickView = (item) => {
    if (!dialog || !dialogContent) return;
    track('nini_favorite_quick_view', {
      product_id: item.id,
      product_title: item.title,
      product_url: item.url,
    });
    const image = item.image
      ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" loading="lazy">`
      : '<span class="nini-favorite-dialog-card__placeholder">nini</span>';
    dialogContent.innerHTML = `
      <div class="nini-favorite-dialog-card">
        ${image}
        <div>
          <span class="nini-favorite-card__club-label">♕ nini CLUB 会員特典対象</span>
          <h2>${escapeHtml(item.title)}</h2>
          <div class="nini-favorite-card__price">
            <strong>${escapeHtml(item.price || '価格を見る')}</strong>
            ${item.compareAtPrice ? `<s>${escapeHtml(item.compareAtPrice)}</s>` : ''}
          </div>
          <p>保存した“好き”を見返して、推し活にぴったりの組み合わせをチェック。気になるアイテムはカートに入れておくとスムーズです。</p>
          <div class="nini-favorite-dialog-card__buttons">
            <a href="${escapeHtml(item.url)}">商品詳細を見る</a>
            <button type="button" data-nini-favorites-dialog-cart ${isPublicPurchaseBlocked(item) ? 'disabled' : ''}>カートに追加</button>
          </div>
        </div>
      </div>
    `;
    dialogContent.querySelector('[data-nini-favorites-dialog-cart]')?.addEventListener('click', (event) => {
      addToCart(item, event.currentTarget);
    });
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
  };

  const openNotifyDialog = (item) => {
    const notifyType = 'restock';
    const notifyLabel = '再入荷通知';
    const productUrl = item.url || notifyUrl;
    const body = [
      `通知種別: ${notifyLabel}`,
      `商品名: ${item.title}`,
      `商品URL: ${productUrl}`,
      `商品ID: ${item.id}`,
      '',
      'この商品の再入荷のお知らせを希望します。',
    ].join('\n');

    track('nini_favorite_notify_open', {
      product_id: item.id,
      product_title: item.title,
      notify_type: notifyType,
    });

    if (notifyMode === 'link' || !notifyDialog || !notifyForm) {
      const targetUrl = item.notifyUrl || `${productUrl}${String(productUrl).includes('?') ? '&' : '?'}nini_notify=${notifyType}`;
      window.location.href = targetUrl;
      return;
    }

    if (notifyTitleElement) notifyTitleElement.textContent = `${notifyLabel}を受け取る`;
    if (notifyTextElement) notifyTextElement.textContent = `${item.title} の${notifyLabel}リクエストを送信します。`;
    if (notifyBodyInput) notifyBodyInput.value = body;
    if (notifyProductInput) notifyProductInput.value = item.title;
    if (notifyTypeInput) notifyTypeInput.value = notifyLabel;
    if (notifyEmailInput && customerEmail && !notifyEmailInput.value) notifyEmailInput.value = customerEmail;

    if (typeof notifyDialog.showModal === 'function') {
      notifyDialog.showModal();
    } else {
      notifyDialog.setAttribute('open', '');
    }
    notifyEmailInput?.focus?.();
  };

  root.addEventListener('click', (event) => {
    const filterButton = event.target.closest('[data-nini-favorites-filter]');
    if (filterButton) {
      activeFilter = filterButton.dataset.niniFavoritesFilter || 'all';
      root.querySelectorAll('[data-nini-favorites-filter]').forEach((button) => {
        button.classList.toggle('is-active', button === filterButton);
      });
      render();
      track('nini_favorite_filter', { filter: activeFilter });
      return;
    }

    const viewButton = event.target.closest('[data-nini-favorites-view]');
    if (viewButton) {
      activeView = viewButton.dataset.niniFavoritesView || 'grid';
      root.querySelectorAll('[data-nini-favorites-view]').forEach((button) => {
        button.classList.toggle('is-active', button === viewButton);
      });
      render();
      track('nini_favorite_view_change', { view: activeView });
      return;
    }

    const closeButton = event.target.closest('[data-nini-favorites-dialog-close]');
    if (closeButton) {
      dialog?.close?.();
      dialog?.removeAttribute('open');
      notifyDialog?.close?.();
      notifyDialog?.removeAttribute('open');
      return;
    }

    const item = findItemFromElement(event.target);
    if (!item) return;

    if (event.target.closest('[data-nini-favorites-heart]')) {
      if (item.source === 'recommendation') {
        addFavorite(item);
      } else {
        removeFavorite(item);
      }
      return;
    }

    if (event.target.closest('[data-nini-favorites-quick]')) {
      openQuickView(item);
      return;
    }

    const cartButton = event.target.closest('[data-nini-favorites-cart]');
    if (cartButton) {
      addToCart(item, cartButton);
      return;
    }

    if (event.target.closest('[data-nini-favorites-notify]')) {
      track('nini_favorite_notify_click', {
        product_id: item.id,
        product_title: item.title,
        notify_type: item.available ? 'sale' : 'restock',
      });
      openNotifyDialog(item);
    }
  });

  notifyForm?.addEventListener('submit', () => {
    track('nini_favorite_notify_submit', {
      notify_type: notifyTypeInput?.value || '',
      product_title: notifyProductInput?.value || '',
    });
  });

  sortSelect?.addEventListener('change', () => {
    render();
    track('nini_favorite_sort', { sort: sortSelect.value });
  });
  window.addEventListener('storage', (event) => {
    if (event.key === storageKey) render();
  });
  window.addEventListener('nini:favorites:changed', render);
  window.addEventListener('nini:wishlist:sync', (event) => {
    const items = Array.isArray(event.detail?.items) ? event.detail.items : [];
    const normalized = uniqueById(items.map(normalizeExternalFavorite).filter(Boolean));
    if (normalized.length > 0) {
      writeFavorites(normalized);
      track('nini_wishlist_sync', { favorite_count: normalized.length });
      render();
    }
  });

  window.niniFavoritesBridge = {
    storageKey,
    get: readFavorites,
    sync(items = []) {
      const normalized = uniqueById(items.map(normalizeExternalFavorite).filter(Boolean));
      writeFavorites(normalized);
      track('nini_wishlist_sync', { favorite_count: normalized.length });
      render();
      return normalized.length;
    },
    clear() {
      writeFavorites([]);
      render();
      return true;
    },
  };

  fallbackItems = getFallbackItems();
  render();

  let externalPolls = 0;
  const externalPoll = window.setInterval(() => {
    externalPolls += 1;
    syncExternalIfChanged();
    if (externalPolls >= 20) window.clearInterval(externalPoll);
  }, 800);
  window.addEventListener('pageshow', syncExternalIfChanged);
  window.addEventListener('nini:wishlist:ready', syncExternalIfChanged);
})();
